<nz-page-header [nzTitle]="name"></nz-page-header>

<a [routerLink]="['/dynamic', type, 'new']" nz-button nzType="dashed" class="mb-1" >+ Add New</a>
<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Action</th>
			<th>Name</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="doView(item)">
			<td>
				<a [routerLink]="['/dynamic', type, item.id, 'edit']" class="btn btn-sm btn-secondary">Edit</a>
			</td>
			<td>{{item.name}}</td>
		</tr>
	</tbody>
</nz-table>
